import { createBrowserRouter } from "react-router";

import Home from "../pages/Home/Home";
import Offers from "../pages/Offers/Offers";
import SignIn from "../pages/SignIn/SignIn";
import SignUp from "../pages/SignUp/SignUp";
import ForgetPassword from "../pages/ForgetPassword/ForgetPassword";
import RootLayout from "../Layout/RootLayout";

import ProtectedRoutes from "./WrapperComponent/ProtectedRoutes";
import Profile from "../pages/Profile/Profile";
import CreateListing from "../pages/CreateListing/CreateListing";
import EditListing from "../pages/CreateListing/EditListing";
import Sale from "../pages/sale/Sale";
import Rent from "../pages/rent/Rent";
import SelectedListing from "../pages/SelectedListing/SelectedListing";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: "/category",
        children: [
          {
            path: "offers",
            element: <Offers />
          },
          {
            path: "sale",
            element: <Sale />
          },
          {
            path: "rent",
            element: <Rent />
          },
          {
            path: ":type/:id",
            element: <SelectedListing />
          }
        ]
      },
      {
        path: "/sign-in",
        element: <SignIn />
      },
      {
        path: "/sign-up",
        element: <SignUp />
      },
      {
        path: "/forget-password",
        element: <ForgetPassword />
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoutes route="/sign-in" replace>
            <Profile />
          </ProtectedRoutes>
        )
      },
      {
        path: "/create-listing",
        element: (
          <ProtectedRoutes route="/sign-in" replace>
            <CreateListing />
          </ProtectedRoutes>
        )
      },
      {
        path: "/edit-listing/:id",
        element: (
          <ProtectedRoutes route="/sign-in" replace>
            <EditListing />
          </ProtectedRoutes>
        )
      }
    ]
  }
]);
